import React, { useEffect, useState } from 'react';
import { Typography, Link, Box, Tooltip } from '@mui/material';

const ReadMoreText = ({ text, maxLength = 100, className, sx }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [displayText, setDisplayText] = useState("");

  const toggleReadMore = (expand) => {
    const newText = expand ? text : `${text.substring(0, maxLength)}...`;
    setIsExpanded(expand);
    setDisplayText(newText);
  };

  useEffect(() => {
    if (text && typeof text === "string") {
      if (text.length > maxLength) {
        setDisplayText(`${text.substring(0, maxLength)}...`);
      } else {
        setDisplayText(text);
      }
    }
  }, [text, maxLength]);

  return (
    <Box>
      <Tooltip
        title={text}
        placement="right-start"
        arrow
        followCursor
      >

        <Typography variant="body1" component="p" className={className} sx={sx}>
          {displayText}
        </Typography>
      </Tooltip>
      {text && typeof text === "string" && text.length > maxLength && (
        <Link
          component="button"
          onClick={() => toggleReadMore(!isExpanded)}
          underline="none"
          style={{ color: '#403e9f' }}
        >
          {isExpanded ? 'Read Less' : 'Read More'}
        </Link>
      )}
    </Box>
  );
};

export default ReadMoreText;
